<template>
  <div class="layout my-papers">
    <div class="top">
      <div class="mt-imgbox" @click="LinkToMyInfo()">
        <img v-if="userInfo.avatarUrl" :src="userInfo.avatarUrl" />
        <img v-else src="@/assets/img/avatar.png"  />
      </div>
    </div>
    <div class="card_content" v-if="list.length">
      <div
        class="card_item"
        :class="{ is_show: item.isShow }"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="card_top">
          <div class="card_title">
            <p class="van-ellipsis">{{item.titleEn||item.title }}</p>
            <span @click="item.isShow = !item.isShow">{{
              item.isShow ? "close" : "open"
            }}</span>
          </div>
          <div class="time_addr">
            <p v-if="item.validTime">Date： {{ item.validTime }}</p>
            <p v-if="item.addressEn">Venue：{{ item.addressEn }}</p>
            <p v-else-if="item.address">Venue：{{ item.address }}</p>
          </div>
        </div>
        <div class="card_bottom">
          <template v-show="item.isShow">
            <div class="card_number" v-show="item.isShow">
              Code：{{ item.code }}
            </div>
            <div class="card_swiper" v-show="item.isShow">
              <van-swipe class="my-swipe" indicator-color="#cdcbcc">
                <van-swipe-item>
                  <canvas
                    :id="'tiao_code' + index"
                    class="my_code code_canvas"
                  ></canvas>
                </van-swipe-item>
                <van-swipe-item>
                  <div class="my_code">
                    <span :id="'my_qrcode' + index"></span>
                  </div>
                </van-swipe-item>
              </van-swipe>
            </div>
          </template>
        </div>
        <div class="card_line">
          <div class="dot dot_left"></div>
          <div class="dot dot_right"></div>
        </div>
      </div>
    </div>
    <div class="card_content" v-if="CardList.length">
      <div
        class="card_item is_show card_buy"
        v-for="(item, index) in CardList"
        :key="index"
      >
        <div class="card_top">
          <div class="card_title">
            <p class="van-ellipsis">{{ item.activity.title }}</p>
            <!-- <span @click="item.isShow = !item.isShow"
              >{{ item.isShow ? "收起" : "展开" }}证件</span
            > -->
          </div>
          <div class="time_addr">
            <p class="flex-p">
              <span>ticket：{{ item.ticketName }}</span>
              <span>number：{{ item.number }}</span>
            </p>
            <p class="flex-p">
              <span>联系人：{{ item.activityReg.fullName }}</span>
              <span>phone：{{ item.activityReg.phoneNumber }}</span>
            </p>
            <p v-if="item.validStartAt && item.validEndAt">
              Date： {{ item.validStartAt | moment("YYYY/MM/DD") }} ~
              {{ item.validEndAt | moment("MM/DD") }}
            </p>
            <p v-if="item.activity.address">
              Venue：{{ item.activity.address }}
            </p>
          </div>
        </div>
        <!-- <div class="card_line">
          <div class="dot dot_left"></div>
          <div class="dot dot_right"></div>
        </div> -->
      </div>
    </div>
    <div class="card_no" v-if="!list.length && !CardList.length">
      Failed to get ticket information
    </div>

    <div class="card_hint" v-if="exhibitionConfig.visitorReg.notice">
      <div class="hint_title">
        Please show this page when entering <br />
        the exhibition hall
      </div>
      <div class="hint_card">
        <div class="hint_line">
          <span></span>Notice<span class="right"></span>
        </div>
        <p>{{ exhibitionConfig.visitorReg.notice }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import JsBarcode from "jsbarcode"; // 条形码
import QRCode from "qrcodejs2";
import gql from "graphql-tag";
import moment from "moment";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "my-papers",
  components: {},
  data() {
    return {
      list: [],
      getMemberCertificates: {},
      CardList: [],
      queryActivityTicket: {},
    };
  },
  async created() {
    this.$store.commit("setExhibitionId", this.$route.params.id);
    if (!this.userInfo) {
      await this.$Myapollo.getUserInfo(this);
    }
    if (!this.exhibitionInfo) {
      await this.$Myapollo.getExhibitionInfo(
        this,
        this.$route.params.id,
        this.userInfo.userId
      );
    }
    this.getPapers();
    // this.getPapersCard();
  },
  mounted() {},
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId: "getExhibitionId",
      exhibitionConfig: "getExhibitionConfig",
    }),
  },
  methods: {
    LinkToMyInfo() {
      this.$router.push(`/my-center/${this.exhibitionId}`);
    },
    JsBarcode(code, index) {
      // 加载二维码 reqBody = null;
      JsBarcode("#tiao_code" + index, code, {
        displayValue: false, //是否在条形码下方显示文字
      });
      const qrCode = new QRCode("my_qrcode" + index, {
        width: 125, // 设置宽度
        height: 125, // 设置高度
        text: code,
        correctLevel: 3,
      });
    },
    // 获取参观证
    getPapers() {
      this.$toast.loading("loading...");
      let query = gql`
        query getMemberCertificates($exhibitionId: Guid!, $userId: String!) {
          getMemberCertificates(exhibitionId: $exhibitionId, userId: $userId) {
            title
            titleEn
            code
            address
            addressEn
            exhibitionId
            id
            type
            typeId
            validEndAt
            validStartAt
          }
        }
      `;
      this.$apollo.addSmartQuery("getMemberCertificates", {
        query: query,
        variables: {
          exhibitionId: this.exhibitionId,
          userId: this.userInfo.userId,
        },
        fetchPolicy: "network-only", //清理缓存
        result(data) {
          let res = JSON.parse(JSON.stringify(data.data.getMemberCertificates));
          // let res=data.data.queryProduct;
          // console.log(res,'证件')
          res.forEach((e) => {
            e.isShow = true;
            e.validTime =
              moment(e.validStartAt).format("YYYY/MM/DD") +
              "~" +
              moment(e.validEndAt).format("MM/DD");
          });
          this.list = res; //
          this.$nextTick(() => {
            this.list.forEach((el, index) => {
              this.JsBarcode(el.code, index);
            });
            this.$toast.clear();
          });
        },
        error(err) {
          this.$toast.clear();
          console.log("err", err);
        },
      });
    },
    // 获取票据
    getPapersCard() {
      this.$toast.loading("loading...");
      let query = gql`
        query queryActivityTicket($query: QueryInput!) {
          queryActivityTicket(query: $query) {
            items {
              activity {
                address
                title
              }
              activityReg {
                fullName
                phoneNumber
              }
              number
              ticketName
              validEndAt
              validStartAt
            }
          }
        }
      `;
      this.where = {
        Equal: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
        Equal2: {
          n: "memberId",
          v: this.userInfo.id,
        },
      };
      this.$apollo.addSmartQuery("queryActivityTicket", {
        query: query,
        variables: {
          query: {
            page: 1,
            size: 50,
            where: JSON.stringify(this.where),
            order: JSON.stringify(this.order),
          },
        },
        fetchPolicy: "network-only", //清理缓存
        result(data) {
          let res = JSON.parse(JSON.stringify(data.data.queryActivityTicket));
          // let res=data.data.queryProduct;
          this.CardList = res.items; //
          console.log(this.CardList, "this.CardList");
          // this.$nextTick(() => {
          //   this.list.forEach((el, index) => {
          //     this.JsBarcode(el.code, index);
          //   });
          //   this.$toast.clear();
          // });
        },
        error(err) {
          this.$toast.clear();
          console.log("err", err);
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.my-papers {
  .top {
    background-image: url("../../../assets/img/new/bg-my.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #fff;
    padding: 0.8rem 0.3rem 0;
    .mt-imgbox {
      width: 1.1rem;
      height: 1.1rem;
      position: relative;
      text-align: center;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 0.03rem solid #fff;
      }
    }
  }
  .card_content {
    padding: 0.3rem 0.3rem 0;
    .card_item {
      height: 2.65rem;
      width: 100%;
      position: relative;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      box-shadow: 0px 0.03rem 0.1rem 0px rgba(0, 0, 0, 0.2);
      margin-bottom: 0.3rem;
      border-radius: 0.08rem;
      &:last-child {
        margin-bottom: 0;
      }
      &:nth-child(even) {
        .card_top,
        .card_bottom {
          border-color: rgba(255, 90, 109, 0.66);
        }
        .card_line {
          &::after {
            border-color: #fb8e9a;
          }
          .dot {
            border-color: #ff929f;
          }
        }
      }
      .card_top,
      .card_bottom {
        border: 1px solid rgba(24, 144, 255, 0.66);
        height: calc((100% - 0.18rem) / 2);
        padding: 0 0.24rem;
        &.card_top {
          border-radius: 0.08rem 0.08rem 0 0;
          border-bottom: none;
          .card_title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-top: 0.4rem;
            p {
              font-size: 0.3rem;
              color: #333;
              font-weight: bold;
            }
            span {
              font-size: 0.22rem;
              color: #1890ff;
            }
          }
          .time_addr {
            position: absolute;
            height: calc(100% / 2);
            // background: #000;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            left: 0.26rem;
            right: 0.25rem;
            padding: 0.26rem 0;
            bottom: 0;
            p {
              color: #666;
              font-size: 0.28rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        &.card_bottom {
          border-top: none;
          border-radius: 0 0 0.08rem 0.08rem;
        }
      }
      .card_line {
        position: absolute;
        height: 0.18rem;
        top: 50%;
        left: 0;
        right: 0;
        transform: translateY(-50%);
        &::after {
          position: absolute;
          content: "";
          display: block;
          border-top: 1px dashed #1890ff;
          left: 0.11rem;
          right: 0.11rem;
          top: 50%;
          transform: translateY(-50%);
        }
        .dot {
          border: 1px solid #6ab7fe;
          width: 0.12rem;
          height: 0.18rem;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          box-shadow: inset 0px 3px 10px 0px rgba(0, 0, 0, 0.1);
          &.dot_left {
            border-left: none;
            left: 0;
            border-radius: 0 100% 100% 0 / 50%;
          }
          &.dot_right {
            border-right: none;
            right: 0;
            border-radius: 100% 0 0 100% / 50%;
          }
        }
      }
      //展开状态
      &.is_show {
        height: auto;
        .card_top {
          height: 2.65rem;
          margin-bottom: 0.14rem;
          .card_title {
            height: auto;
            border-bottom: 0.02rem solid #d9d9d9;
            padding-bottom: 0.49rem;
          }
          .time_addr {
            position: initial;
            height: 1.6rem;
            padding: 0.23rem 0 0.55rem;
          }
        }
        .card_bottom {
          height: 4.8rem;
          padding: 0.6rem 0.24rem 0;
          text-align: center;
          .card_number {
            font-size: 0.28rem;
            color: #333;
            font-weight: bold;
            margin-bottom: 0.3rem;
          }
          .card_swiper {
            height: 3.3rem;
            width: 4.8rem;
            margin: 0 auto;
            ::v-deep .my-swipe {
              height: 100%;
              width: 100%;
              .van-swipe__indicators {
                .van-swipe__indicator {
                  background: #f1f1f1;
                  opacity: 1;
                }
              }
              .van-swipe-item {
                width: 100%;
                height: 2.8rem;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                  max-width: 100%;
                  max-height: 100%;
                }
                .my_code {
                  width: 100%;
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  &.code_canvas {
                    height: 2.5rem;
                  }
                }
              }
            }
          }
        }
        .card_line {
          transform: initial;
          top: 2.64rem;
          &::after {
            border-width: 1px;
          }
        }
      }
    }
    .card_buy {
      border: 1px solid rgba(24, 144, 255, 0.66);
      .card_top {
        height: auto !important;
        margin-bottom: 0 !important;
        border-radius: 0.08rem !important;
        border: none;
      }
      .time_addr {
        height: auto !important;
        .flex-p {
          span {
            display: inline-block;
            width: 50%;
            font-size: 0.28rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
  .card_no {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0.3rem;
    height: 2.65rem;
    background-color: #fff;
    color: #333;
    font-size: 0.26rem;
    box-shadow: 0px 0.03rem 0.1rem 0.1rem rgba(0, 0, 0, 0.1);
    border-radius: 0.1rem;
  }
  .card_hint {
    text-align: center;
    .hint_title {
      padding: 0.26rem 0.3rem;
      color: #0290fe;
      font-size: 0.28rem;
    }
    .hint_card {
      background: url("../../../assets/img/new/card_hint_bg.png");
      background-size: 100% 100%;
      padding-top: 0.14rem;
      padding-bottom: 0.32rem;
      min-height: 2.02rem;
      text-align: center;
      color: #fff;
      .hint_line {
        font-size: 0.3rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        padding-top: 0.2rem;
        span {
          display: block;
          width: 1.94rem;
          height: 0.01rem;
          background-image: linear-gradient(
            to right,
            rgba(255, 255, 255, 0),
            rgba(255, 255, 255, 1) 100%
          );
          margin-right: 0.35rem;
          position: relative;
          transform: scale(1.001);
          &::after {
            content: "";
            display: block;
            width: 0.03rem;
            height: 0.03rem;
            border-radius: 50%;
            background: #fff;
            position: absolute;
            top: 0;
            transform: translateY(-0.01rem);
            right: 0.01rem;
          }
          &.right {
            &::after {
              right: auto;
              left: 0;
            }
            margin-right: 0;
            margin-left: 0.35rem;
            background-image: linear-gradient(
              to left,
              rgba(255, 255, 255, 0),
              rgba(255, 255, 255, 1) 100%
            );
          }
        }
      }
      p {
        font-size: 0.28rem;
        margin: 0.18rem 0;
        padding: 0 0.6rem;
      }
    }
  }
}
.circle1 {
  width: 100px;
  height: 50px;
  border-radius: 50px 50px 0 0;
  line-height: 50px;
}
.circle3 {
  width: 100px;
  height: 50px;
  border-radius: 0 0 50px 50px;
  line-height: 50px;
}
.circle2 {
  width: 50px;
  height: 100px;
  border-radius: 0 50px 50px 0;
  line-height: 100px;
}
.circle4 {
  width: 50px;
  height: 100px;
  border-radius: 50px 0 0 50px;
  line-height: 100px;
}
.circle5 {
  width: 100px;
  height: 100px;
  border-radius: 50px;
  line-height: 100px;
}
</style>
